import React from "react";
import { IoMdDownload } from "react-icons/io";

export default function MobOldDocument({ documents = [], onDownload }) {
  if (!documents || documents.length === 0) {
    return (
      <p className="text-center text-gray-500 text-sm py-6">
        No documents found
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {documents.map((doc, index) => (
        <div
          key={doc.id || index}
          className="bg-white border rounded-md shadow-sm p-4"
        >
          {/* Document Name */}
          <p className="text-sm font-semibold text-gray-800 mb-1">
            {doc.documentName}
          </p>

          {/* File name */}
          <p className="text-xs text-gray-500 mb-1">
            {doc.fileName}
          </p>

          {/* Meta info */}
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600 mb-3">
            <span className="capitalize">
              <strong>Type:</strong> {doc.documentType}
            </span>
            <span>
              <strong>Date:</strong> {doc.uploadDate}
            </span>
            <span>
              <strong>By:</strong> {doc.uploadBy}
            </span>
          </div>

          {/* Action */}
          <div className="flex justify-end">
            <button
              onClick={() => onDownload(doc)}
              className="h-9 w-9 rounded-full bg-blue-50 flex items-center justify-center hover:bg-blue-100 transition"
            >
              <IoMdDownload className="text-blue-600 text-lg" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
